import { setCssVar } from '@/utils/common'
/**
* @description 皮肤、主题
* @date 2023-10-30 15:24:23
* @author 2028
*/
export default {
  namespaced: true,
  state: {
    curTheme: '#1767e3', // 选中的主题
    themeList: [
      {
        theme: '#1767e3',
        color: '#1767e3',
        cssVar: {
          test: '#1767e3',
        }
      },
      {
        theme: '#ff5c93',
        color: '#ff5c93',
        cssVar: {
          test: '#ff5c93',
        }
      }
    ], // 主题列表
  },
  mutations: {
    setCurTheme(state, theme) {
      state.curTheme = theme
      const item = state.themeList.find(item => theme === item.theme)
      setCssVar('--test', item.cssVar.test)
    }
  },
  actions: {}
}
